module.exports = __webpack_public_path__ + "img/ikon.3fabbffa.png";